import React from "react";
import classNames from "classnames";
import FormInput from "src/components/Common/Form/FormInput";
import FormTextarea from "src/components/Common/Form/FormTextarea";
import { ButtonEdit } from "src/components/Common/Button";
import ProtectedComponent from "src/components/Permission";
import TooltipWrapper from "src/components/Common/TooltipWrapper";

const EditableField = ({
  className = "",
  label,
  fieldName,
  value,
  setValue,
  register,
  errors,
  placeholder,
  isRequired = true,
  requiredMessage,
  maxLength = 255,
  maxLengthMessage,
  isAllowEdit = false,
  isTextarea = false,
  rows = 4,
  pattern,
  errorsRelative = false,
  disabled = false,
  tooltipText = "edit",
  translation = "project-instance",
}) => {
  const [isEditingState, setIsEditingState] = React.useState(false);

  React.useEffect(() => {
    setValue(fieldName, value || "");
  }, [fieldName, value, setValue]);

  const renderFormField = () => {
    if (isTextarea) {
      return (
        <FormTextarea
          register={register}
          name={fieldName}
          placeholder={placeholder}
          errors={errors?.[fieldName]?.message}
          requiredMessage={requiredMessage}
          classGroup="mb-0 width-full"
          classInput="height-by-px-129"
          rows={rows}
          required={isRequired}
          maxLength={maxLength}
          maxLengthMessage={maxLengthMessage}
          pattern={pattern}
        />
      );
    }

    return (
      <FormInput
        register={register}
        name={fieldName}
        placeholder={placeholder}
        errors={errors?.[fieldName]?.message}
        requiredMessage={requiredMessage}
        required={isRequired}
        maxLength={maxLength}
        maxLengthMessage={maxLengthMessage}
        classGroup="mb-0 width-full"
        pattern={pattern}
        errorsRelative={errorsRelative}
      />
    );
  };

  return (
    <div
      className={classNames(`row ${className}`, {
        "mb-1": !isEditingState,
        "mb-3": isEditingState && !(errorsRelative && errors?.[fieldName]?.message),
        "m-b-4": isEditingState && errorsRelative && errors?.[fieldName]?.message,
        "align-items-baseline": !isAllowEdit || (isEditingState && errorsRelative),
        "align-items-center": isAllowEdit && !isTextarea,
        "align-items-start": isAllowEdit && isTextarea,
      })}
    >
      <div className="col-md-3 p-y-8">
        <label className={classNames("form-label mb-0 position-relative", { "required-input": isRequired })}>{label}:</label>
      </div>
      <div className="col-md-9">
        <div className="d-flex align-items-baseline">
          <div
            className={classNames("flex-grow-1", {
              "d-none": !isEditingState,
              "d-block": isEditingState,
            })}
          >
            {renderFormField()}
          </div>
          {isEditingState && (
            <button
              className="btn btn-blank text-dark p-1"
              onClick={() => {
                setValue(fieldName, value || "");
                setIsEditingState(false);
              }}
            >
              <i className="bi bi-x-lg" />
            </button>
          )}
          {isAllowEdit ? (
            <div
              className={classNames("flex-grow-1 d-flex align-items-center gap-1", {
                "d-none": isEditingState,
                "d-block": !isEditingState,
              })}
            >
              <TooltipWrapper
                id="instance-editable-field"
                tooltipText={value || ""}
                checkOverflow={true}
                tooltipClassName="max-width-by-px-300"
              >
                <p className="mb-0 max-width-by-px-256 overflow-hidden text-truncate">{value || ""}</p>
              </TooltipWrapper>
              <ProtectedComponent id={`project_instance_detail_${fieldName}`}>
                <ButtonEdit
                  isShow={!isEditingState}
                  handleClick={() => setIsEditingState(true)}
                  id={fieldName}
                  disabled={disabled}
                  tooltipText={tooltipText}
                  translation={translation}
                />
              </ProtectedComponent>
            </div>
          ) : (
            <p className="mb-0">{value || ""}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default EditableField;
